/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig, ApiException } from  '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IProviderManagementPublicClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    submitApplication(body?: SubmitApplicationRequestDto | undefined): Promise<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateContactDetails(body?: UpdateContactDetailsDto | undefined): Promise<number>;
    /**
     * @return Success
     */
    validateContactDetails(taxpayerID: number, oTPcode: string | null, contactType: ContactTypes): Promise<number>;
    /**
     * @return Success
     */
    getIntermediaries(): Promise<GetIntermediaryExternalResponseDto>;
     /**
     * This API is responsible for retrieving full information about specific intermediary.
     * @param taxpayerId Taxpayer Id.
     * @param attachmentId Attachment Id.
     * @return Success
     */
    getAttachmentContent(taxpayerId: number, attachmentId: number): Promise<string>;
    /**
     * @return Success
     */
    getDetails(): Promise<IntermediaryDetailsResponseDto>;
    /**
     * @param representedTaxPayerName (optional) 
     * @param representedTaxPayerNameAr (optional) 
     * @param representedTaxPayerId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getRepresentedTaxpayers(representedTaxPayerName?: string | null | undefined, representedTaxPayerNameAr?: string | null | undefined, representedTaxPayerId?: number | undefined, dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined): Promise<GetRepresentedTaxpayersExternalResponseDto>;
    /**
     * @param name (optional) 
     * @param nameAr (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getTaxpayerIntermediaries(name?: string | null | undefined, nameAr?: string | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined): Promise<GetTaxpayerIntermediariesResponseDto>;
    /**
     * This API allows taxpayer representative with administrative rights to define which of the active intermediaries will be able to represent it.
     * @param body (optional) Active Intermediary Taxpayer Representation List
    Inactive Intermediary Taxpayer Representation List.
     * @return Success
     */
    saveTaxpayerIntermediaries(body?: IntermediaryRepresentationsRequestDto | undefined): Promise<number>;
    /**
     * Api to view details of representation.
     * @param representionID representation identifier.
     * @return Success
     */
    getRepresentationDetails(representionID: number): Promise<GetRepresentationDetailsExternalResponseDto>;
    /**
     * The Lookups and Configuration of intermediaries.
     * @return Success
     */
     getConfig(): Promise<GetConfigResponse>;
}

export class ProviderManagementPublicClient extends BaseClientApi implements IProviderManagementPublicClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitApplication(body?: SubmitApplicationRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/current/application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitApplication(_response);
        });
    }

    protected processSubmitApplication(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateContactDetails(body?: UpdateContactDetailsDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/current/contactdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactDetails(_response);
        });
    }

    protected processUpdateContactDetails(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    validateContactDetails(taxpayerID: number, oTPcode: string | null, contactType: ContactTypes , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/{TaxpayerID}/contactdetails/{ContactType}/validation/{OTPcode}";
        if (taxpayerID === undefined || taxpayerID === null)
            throw new Error("The parameter 'taxpayerID' must be defined.");
        url_ = url_.replace("{TaxpayerID}", encodeURIComponent("" + taxpayerID));
        if (oTPcode === undefined || oTPcode === null)
            throw new Error("The parameter 'oTPcode' must be defined.");
        url_ = url_.replace("{OTPcode}", encodeURIComponent("" + oTPcode));
        if (contactType === undefined || contactType === null)
            throw new Error("The parameter 'contactType' must be defined.");
        url_ = url_.replace("{ContactType}", encodeURIComponent("" + contactType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateContactDetails(_response);
        });
    }

    protected processValidateContactDetails(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    getIntermediaries(  cancelToken?: CancelToken | undefined): Promise<GetIntermediaryExternalResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntermediaries(_response);
        });
    }

    protected processGetIntermediaries(response: AxiosResponse): Promise<GetIntermediaryExternalResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIntermediaryExternalResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIntermediaryExternalResponseDto>(<any>null);
    }
  /**
     * This API is responsible for retrieving full information about specific intermediary.
     * @param taxpayerId Taxpayer Id.
     * @param attachmentId Attachment Id.
     * @return Success
     */
   getAttachmentContent(taxpayerId: number, attachmentId: number , cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + "/api/v{version}/intermediaries/{taxpayerId}/attachments/{attachmentId}";
    if (taxpayerId === undefined || taxpayerId === null)
        throw new Error("The parameter 'taxpayerId' must be defined.");
    url_ = url_.replace("{taxpayerId}", encodeURIComponent("" + taxpayerId));
    if (attachmentId === undefined || attachmentId === null)
        throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
        method: "GET",
        url: url_,
        headers: {
            "Accept": "text/plain"
        },
        cancelToken
    };

    return this.transformOptions(options_).then(transformedOptions_ => {
        return this.instance.request(transformedOptions_);
    }).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return this.processGetAttachmentContent(_response);
    });
}

protected processGetAttachmentContent(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return result200;
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(<any>null);
}
    /**
     * @return Success
     */
    getDetails(  cancelToken?: CancelToken | undefined): Promise<IntermediaryDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<IntermediaryDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntermediaryDetailsResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediaryDetailsResponseDto>(<any>null);
    }

    /**
     * @param representedTaxPayerName (optional) 
     * @param representedTaxPayerNameAr (optional) 
     * @param representedTaxPayerId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getRepresentedTaxpayers(representedTaxPayerName?: string | null | undefined, representedTaxPayerNameAr?: string | null | undefined, representedTaxPayerId?: number | undefined, dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetRepresentedTaxpayersExternalResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/current/representations?";
        if (representedTaxPayerName !== undefined && representedTaxPayerName !== null)
            url_ += "RepresentedTaxPayerName=" + encodeURIComponent("" + representedTaxPayerName) + "&";
        if (representedTaxPayerNameAr !== undefined && representedTaxPayerNameAr !== null)
            url_ += "RepresentedTaxPayerNameAr=" + encodeURIComponent("" + representedTaxPayerNameAr) + "&";
        if (representedTaxPayerId === null)
            throw new Error("The parameter 'representedTaxPayerId' cannot be null.");
        else if (representedTaxPayerId !== undefined)
            url_ += "RepresentedTaxPayerId=" + encodeURIComponent("" + representedTaxPayerId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRepresentedTaxpayers(_response);
        });
    }

    protected processGetRepresentedTaxpayers(response: AxiosResponse): Promise<GetRepresentedTaxpayersExternalResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRepresentedTaxpayersExternalResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRepresentedTaxpayersExternalResponseDto>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param nameAr (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getTaxpayerIntermediaries(name?: string | null | undefined, nameAr?: string | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetTaxpayerIntermediariesResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/representations/current?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (nameAr !== undefined && nameAr !== null)
            url_ += "NameAr=" + encodeURIComponent("" + nameAr) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxpayerIntermediaries(_response);
        });
    }

    protected processGetTaxpayerIntermediaries(response: AxiosResponse): Promise<GetTaxpayerIntermediariesResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaxpayerIntermediariesResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaxpayerIntermediariesResponseDto>(<any>null);
    }

   /**
     * This API allows taxpayer representative with administrative rights to define which of the active intermediaries will be able to represent it.
     * @param body (optional) Active Intermediary Taxpayer Representation List
    Inactive Intermediary Taxpayer Representation List.
     * @return Success
     */
    saveTaxpayerIntermediaries(body?: IntermediaryRepresentationsRequestDto | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/representations/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).then((_response: AxiosResponse) => {
            return this.processSaveTaxpayerIntermediaries(_response);
        });
    }

    protected processSaveTaxpayerIntermediaries(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * Api to view details of representation.
     * @param representionID representation identifier.
     * @return Success
     */
    getRepresentationDetails(representionID: number): Promise<GetRepresentationDetailsExternalResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/representations/{representionID}/repdetails";
        if (representionID === undefined || representionID === null)
            throw new Error("The parameter 'representionID' must be defined.");
        url_ = url_.replace("{representionID}", encodeURIComponent("" + representionID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).then((_response: AxiosResponse) => {
            return this.processGetRepresentationDetails(_response);
        });
    }

    protected processGetRepresentationDetails(response: AxiosResponse): Promise<GetRepresentationDetailsExternalResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRepresentationDetailsExternalResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRepresentationDetailsExternalResponseDto>(<any>null);
    }
   
    /**
     * The Lookups and Configuration of intermediaries.
     * @return Success
     */
     getConfig(  cancelToken?: CancelToken | undefined): Promise<GetConfigResponse> {
        let url_ = this.baseUrl + "/api/v{version}/intermediaries/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: AxiosResponse): Promise<GetConfigResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConfigResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConfigResponse>(<any>null);
    }
}

export class LookupsDto implements ILookupsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    parentCode?: string | undefined;

    constructor(data?: ILookupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.parentCode = _data["parentCode"];
        }
    }

    static fromJS(data: any): LookupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["parentCode"] = this.parentCode;
        return data; 
    }

    clone(): LookupsDto {
        const json = this.toJSON();
        let result = new LookupsDto();
        result.init(json);
        return result;
    }
}

export interface ILookupsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    parentCode?: string | undefined;
}

export class ClaimLookupDto implements IClaimLookupDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    parentCode?: string | undefined;
    alwaysEnabled?: boolean | undefined;
    enabled?: boolean | undefined;

    constructor(data?: IClaimLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentCode = _data["parentCode"];
            this.alwaysEnabled = _data["alwaysEnabled"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ClaimLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["alwaysEnabled"] = this.alwaysEnabled;
        data["enabled"] = this.enabled;
        return data; 
    }

    clone(): ClaimLookupDto {
        const json = this.toJSON();
        let result = new ClaimLookupDto();
        result.init(json);
        return result;
    }
}

export interface IClaimLookupDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    parentCode?: string | undefined;
    alwaysEnabled?: boolean | undefined;
    enabled?: boolean | undefined;
}

export class GetConfigResponse implements IGetConfigResponse {
    claimsCategory?: LookupsDto[] | undefined;
    claims?: ClaimLookupDto[] | undefined;

    constructor(data?: IGetConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claimsCategory"])) {
                this.claimsCategory = [] as any;
                for (let item of _data["claimsCategory"])
                    this.claimsCategory!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(ClaimLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claimsCategory)) {
            data["claimsCategory"] = [];
            for (let item of this.claimsCategory)
                data["claimsCategory"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetConfigResponse {
        const json = this.toJSON();
        let result = new GetConfigResponse();
        result.init(json);
        return result;
    }
}

export interface IGetConfigResponse {
    claimsCategory?: LookupsDto[] | undefined;
    claims?: ClaimLookupDto[] | undefined;
}
export enum ApplicationTypes {
    None = "None",
    Initial = "Initial",
    Renewal = "Renewal",
}

export class AddressDto implements IAddressDto {
    streetName?: string | undefined;
    buildingNo?: string | undefined;
    flatNo?: string | undefined;
    cityID?: number | undefined;
    governorateID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.buildingNo = _data["buildingNo"];
            this.flatNo = _data["flatNo"];
            this.cityID = _data["cityID"];
            this.governorateID = _data["governorateID"];
            this.countryID = _data["countryID"];
            this.countryCode = _data["countryCode"];
            this.floorNo = _data["floorNo"];
            this.additionalInformation = _data["additionalInformation"];
            this.postalCode = _data["postalCode"];
            this.streetName2 = _data["streetName2"];
            this.foreignGovernorateName = _data["foreignGovernorateName"];
            this.foreignCityName = _data["foreignCityName"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["buildingNo"] = this.buildingNo;
        data["flatNo"] = this.flatNo;
        data["cityID"] = this.cityID;
        data["governorateID"] = this.governorateID;
        data["countryID"] = this.countryID;
        data["countryCode"] = this.countryCode;
        data["floorNo"] = this.floorNo;
        data["additionalInformation"] = this.additionalInformation;
        data["postalCode"] = this.postalCode;
        data["streetName2"] = this.streetName2;
        data["foreignGovernorateName"] = this.foreignGovernorateName;
        data["foreignCityName"] = this.foreignCityName;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    streetName?: string | undefined;
    buildingNo?: string | undefined;
    flatNo?: string | undefined;
    cityID?: number | undefined;
    governorateID?: number | undefined;
    countryID?: number;
    countryCode?: string | undefined;
    floorNo?: string | undefined;
    additionalInformation?: string | undefined;
    postalCode?: string | undefined;
    streetName2?: string | undefined;
    foreignGovernorateName?: string | undefined;
    foreignCityName?: string | undefined;
}

export class ApplicationAttachmentDto implements IApplicationAttachmentDto {
    id?: number;
    fileSize?:number
    fileName?: string;
    fileType?: string;
    fileContentBase64?: string;

    constructor(data?: IApplicationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileContentBase64 = _data["fileContentBase64"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): ApplicationAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileContentBase64"] = this.fileContentBase64;
        data["fileSize"] = this.fileSize;
        return data; 
    }

    clone(): ApplicationAttachmentDto {
        const json = this.toJSON();
        let result = new ApplicationAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationAttachmentDto {
    id?: number;
    fileName?: string;
    fileType?: string;
    fileContentBase64?: string;
}


export class SubmitApplicationRequestDto implements ISubmitApplicationRequestDto {
    intermediaryId?: number | undefined;
    description?: string | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    type?: ApplicationTypes;
    note?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    address?: AddressDto;
    applicationAttachments?: ApplicationAttachmentDto[] | undefined;

    constructor(data?: ISubmitApplicationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intermediaryId = _data["intermediaryId"];
            this.description = _data["description"];
            this.mobileNo = _data["mobileNo"];
            this.email = _data["email"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.note = _data["note"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["applicationAttachments"])) {
                this.applicationAttachments = [] as any;
                for (let item of _data["applicationAttachments"])
                    this.applicationAttachments!.push(ApplicationAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitApplicationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitApplicationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediaryId"] = this.intermediaryId;
        data["description"] = this.description;
        data["mobileNo"] = this.mobileNo;
        data["email"] = this.email;
        data["url"] = this.url;
        data["type"] = this.type;
        data["note"] = this.note;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationAttachments)) {
            data["applicationAttachments"] = [];
            for (let item of this.applicationAttachments)
                data["applicationAttachments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SubmitApplicationRequestDto {
        const json = this.toJSON();
        let result = new SubmitApplicationRequestDto();
        result.init(json);
        return result;
    }
}

export interface ISubmitApplicationRequestDto {
    intermediaryId?: number | undefined;
    description?: string | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    type?: ApplicationTypes;
    note?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    address?: AddressDto;
    applicationAttachments?: ApplicationAttachmentDto[] | undefined;
}

export class UpdateContactDetailsDto implements IUpdateContactDetailsDto {
    email?: string | undefined;
    mobileNo?: string | undefined;
    url?: string | undefined;
    address?: AddressDto;

    constructor(data?: IUpdateContactDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.url = _data["url"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateContactDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["url"] = this.url;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateContactDetailsDto {
        const json = this.toJSON();
        let result = new UpdateContactDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateContactDetailsDto {
    email?: string | undefined;
    mobileNo?: string | undefined;
    url?: string | undefined;
    address?: AddressDto;
}

export enum ContactTypes {
    None = "None",
    Email = "Email",
    Mobile = "Mobile",
}

export enum IntermediaryStatuses {
    None = "None",
    Blocked = "Blocked",
    Unblocked = "Unblocked",
}

export class IntermediaryDto implements IIntermediaryDto {
    id?: number;
    taxpayerId?: number;
    taxpayerRIN?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    status?: IntermediaryStatuses;
    readonly url?: string | undefined;
    address?: AddressDto;

    constructor(data?: IIntermediaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxpayerId = _data["taxpayerId"];
            this.taxpayerRIN = _data["taxpayerRIN"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.mobileNo = _data["mobileNo"];
            this.email = _data["email"];
            this.status = _data["status"];
            (<any>this).url = _data["url"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxpayerId"] = this.taxpayerId;
        data["taxpayerRIN"] = this.taxpayerRIN;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["mobileNo"] = this.mobileNo;
        data["email"] = this.email;
        data["status"] = this.status;
        data["url"] = this.url;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): IntermediaryDto {
        const json = this.toJSON();
        let result = new IntermediaryDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryDto {
    id?: number;
    taxpayerId?: number;
    taxpayerRIN?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    status?: IntermediaryStatuses;
    url?: string | undefined;
    address?: AddressDto;
}

export class GetIntermediaryExternalResponseDto implements IGetIntermediaryExternalResponseDto {
    approvedIntermediaries?: IntermediaryDto[] | undefined;

    constructor(data?: IGetIntermediaryExternalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["approvedIntermediaries"])) {
                this.approvedIntermediaries = [] as any;
                for (let item of _data["approvedIntermediaries"])
                    this.approvedIntermediaries!.push(IntermediaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIntermediaryExternalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntermediaryExternalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.approvedIntermediaries)) {
            data["approvedIntermediaries"] = [];
            for (let item of this.approvedIntermediaries)
                data["approvedIntermediaries"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetIntermediaryExternalResponseDto {
        const json = this.toJSON();
        let result = new GetIntermediaryExternalResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetIntermediaryExternalResponseDto {
    approvedIntermediaries?: IntermediaryDto[] | undefined;
}

export enum Languages {
    None = "None",
    En = "En",
    Ar = "Ar",
}

export class TaxpayerDto implements ITaxpayerDto {
    taxpayerId?: number;
    rin?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    registrationNumber?: string | undefined;
    defaultLanguage?: Languages;
    operationStartDate?: Date | undefined;
    operationEndDate?: Date | undefined;

    constructor(data?: ITaxpayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerId = _data["taxpayerId"];
            this.rin = _data["rin"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.registrationNumber = _data["registrationNumber"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.operationStartDate = _data["operationStartDate"] ? new Date(_data["operationStartDate"].toString()) : <any>undefined;
            this.operationEndDate = _data["operationEndDate"] ? new Date(_data["operationEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxpayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerId"] = this.taxpayerId;
        data["rin"] = this.rin;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["registrationNumber"] = this.registrationNumber;
        data["defaultLanguage"] = this.defaultLanguage;
        data["operationStartDate"] = this.operationStartDate ? this.operationStartDate.toISOString() : <any>undefined;
        data["operationEndDate"] = this.operationEndDate ? this.operationEndDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): TaxpayerDto {
        const json = this.toJSON();
        let result = new TaxpayerDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerDto {
    taxpayerId?: number;
    rin?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    registrationNumber?: string | undefined;
    defaultLanguage?: Languages;
    operationStartDate?: Date | undefined;
    operationEndDate?: Date | undefined;
}

export class ActivityPeriodDto implements IActivityPeriodDto {
    id?: number;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;

    constructor(data?: IActivityPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): ActivityPeriodDto {
        const json = this.toJSON();
        let result = new ActivityPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IActivityPeriodDto {
    id?: number;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
}

export enum ApplicationStatuses {
    None = "None",
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export class ApplicationDto implements IApplicationDto {
    intermediaryId?: number | undefined;
    taxpayerId?: number | undefined;
    taxpayerRIN?: string | undefined;
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    submissionDate?: Date;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: ApplicationStatuses;
    type?: ApplicationTypes;
    description?: string | undefined;
    address?: AddressDto;
    mobileNo?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    applicationAttachments?: ApplicationAttachmentDto[] | undefined;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intermediaryId = _data["intermediaryId"];
            this.taxpayerId = _data["taxpayerId"];
            this.taxpayerRIN = _data["taxpayerRIN"];
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.mobileNo = _data["mobileNo"];
            this.email = _data["email"];
            this.url = _data["url"];
            if (Array.isArray(_data["applicationAttachments"])) {
                this.applicationAttachments = [] as any;
                for (let item of _data["applicationAttachments"])
                    this.applicationAttachments!.push(ApplicationAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediaryId"] = this.intermediaryId;
        data["taxpayerId"] = this.taxpayerId;
        data["taxpayerRIN"] = this.taxpayerRIN;
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["description"] = this.description;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["mobileNo"] = this.mobileNo;
        data["email"] = this.email;
        data["url"] = this.url;
        if (Array.isArray(this.applicationAttachments)) {
            data["applicationAttachments"] = [];
            for (let item of this.applicationAttachments)
                data["applicationAttachments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ApplicationDto {
        const json = this.toJSON();
        let result = new ApplicationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationDto {
    intermediaryId?: number | undefined;
    taxpayerId?: number | undefined;
    taxpayerRIN?: string | undefined;
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    submissionDate?: Date;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: ApplicationStatuses;
    type?: ApplicationTypes;
    description?: string | undefined;
    address?: AddressDto;
    mobileNo?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    applicationAttachments?: ApplicationAttachmentDto[] | undefined;
}

export class IntermediaryStatusDto implements IIntermediaryStatusDto {
    id?: number;
    readonly actionDate?: Date;
    status?: IntermediaryStatuses;
    note?: string | undefined;

    constructor(data?: IIntermediaryStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).actionDate = _data["actionDate"] ? new Date(_data["actionDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): IntermediaryStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionDate"] = this.actionDate ? this.actionDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["note"] = this.note;
        return data; 
    }

    clone(): IntermediaryStatusDto {
        const json = this.toJSON();
        let result = new IntermediaryStatusDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryStatusDto {
    id?: number;
    actionDate?: Date;
    status?: IntermediaryStatuses;
    note?: string | undefined;
}

export class ForcedValidationPeriodDto implements IForcedValidationPeriodDto {
    id?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;

    constructor(data?: IForcedValidationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ForcedValidationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForcedValidationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }

    clone(): ForcedValidationPeriodDto {
        const json = this.toJSON();
        let result = new ForcedValidationPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IForcedValidationPeriodDto {
    id?: number;
    activeFrom?: Date;
    activeTo?: Date | undefined;
}

export class IntermediaryDetailsResponseDto implements IIntermediaryDetailsResponseDto {
    id?: number;
    url?: string | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    status?: IntermediaryStatuses;
    taxpayer?: TaxpayerDto;
    address?: AddressDto;
    recentActivityPeriod?: ActivityPeriodDto;
    activityPeriodHistory?: ActivityPeriodDto[] | undefined;
    recentApplication?: ApplicationDto;
    applicationHistory?: ApplicationDto[] | undefined;
    recentStatus?: IntermediaryStatusDto;
    statusHistory?: IntermediaryStatusDto[] | undefined;
    recentForcedValidationPeriod?: ForcedValidationPeriodDto;
    forcedValidationPeriodHistory?: ForcedValidationPeriodDto[] | undefined;

    constructor(data?: IIntermediaryDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.mobileNo = _data["mobileNo"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.taxpayer = _data["taxpayer"] ? TaxpayerDto.fromJS(_data["taxpayer"]) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.recentActivityPeriod = _data["recentActivityPeriod"] ? ActivityPeriodDto.fromJS(_data["recentActivityPeriod"]) : <any>undefined;
            if (Array.isArray(_data["activityPeriodHistory"])) {
                this.activityPeriodHistory = [] as any;
                for (let item of _data["activityPeriodHistory"])
                    this.activityPeriodHistory!.push(ActivityPeriodDto.fromJS(item));
            }
            this.recentApplication = _data["recentApplication"] ? ApplicationDto.fromJS(_data["recentApplication"]) : <any>undefined;
            if (Array.isArray(_data["applicationHistory"])) {
                this.applicationHistory = [] as any;
                for (let item of _data["applicationHistory"])
                    this.applicationHistory!.push(ApplicationDto.fromJS(item));
            }
            this.recentStatus = _data["recentStatus"] ? IntermediaryStatusDto.fromJS(_data["recentStatus"]) : <any>undefined;
            if (Array.isArray(_data["statusHistory"])) {
                this.statusHistory = [] as any;
                for (let item of _data["statusHistory"])
                    this.statusHistory!.push(IntermediaryStatusDto.fromJS(item));
            }
            this.recentForcedValidationPeriod = _data["recentForcedValidationPeriod"] ? ForcedValidationPeriodDto.fromJS(_data["recentForcedValidationPeriod"]) : <any>undefined;
            if (Array.isArray(_data["forcedValidationPeriodHistory"])) {
                this.forcedValidationPeriodHistory = [] as any;
                for (let item of _data["forcedValidationPeriodHistory"])
                    this.forcedValidationPeriodHistory!.push(ForcedValidationPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediaryDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["mobileNo"] = this.mobileNo;
        data["email"] = this.email;
        data["status"] = this.status;
        data["taxpayer"] = this.taxpayer ? this.taxpayer.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["recentActivityPeriod"] = this.recentActivityPeriod ? this.recentActivityPeriod.toJSON() : <any>undefined;
        if (Array.isArray(this.activityPeriodHistory)) {
            data["activityPeriodHistory"] = [];
            for (let item of this.activityPeriodHistory)
                data["activityPeriodHistory"].push(item.toJSON());
        }
        data["recentApplication"] = this.recentApplication ? this.recentApplication.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationHistory)) {
            data["applicationHistory"] = [];
            for (let item of this.applicationHistory)
                data["applicationHistory"].push(item.toJSON());
        }
        data["recentStatus"] = this.recentStatus ? this.recentStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.statusHistory)) {
            data["statusHistory"] = [];
            for (let item of this.statusHistory)
                data["statusHistory"].push(item.toJSON());
        }
        data["recentForcedValidationPeriod"] = this.recentForcedValidationPeriod ? this.recentForcedValidationPeriod.toJSON() : <any>undefined;
        if (Array.isArray(this.forcedValidationPeriodHistory)) {
            data["forcedValidationPeriodHistory"] = [];
            for (let item of this.forcedValidationPeriodHistory)
                data["forcedValidationPeriodHistory"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IntermediaryDetailsResponseDto {
        const json = this.toJSON();
        let result = new IntermediaryDetailsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryDetailsResponseDto {
    id?: number;
    url?: string | undefined;
    mobileNo?: string | undefined;
    email?: string | undefined;
    status?: IntermediaryStatuses;
    taxpayer?: TaxpayerDto;
    address?: AddressDto;
    recentActivityPeriod?: ActivityPeriodDto;
    activityPeriodHistory?: ActivityPeriodDto[] | undefined;
    recentApplication?: ApplicationDto;
    applicationHistory?: ApplicationDto[] | undefined;
    recentStatus?: IntermediaryStatusDto;
    statusHistory?: IntermediaryStatusDto[] | undefined;
    recentForcedValidationPeriod?: ForcedValidationPeriodDto;
    forcedValidationPeriodHistory?: ForcedValidationPeriodDto[] | undefined;
}

export class RepresentedTaxpayersResponseDto implements IRepresentedTaxpayersResponseDto {
    id?: number;
    taxpayerId?: number;
    taxpayerRIN?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    isActive?: boolean;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    url?: string | undefined;

    constructor(data?: IRepresentedTaxpayersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxpayerId = _data["taxpayerId"];
            this.taxpayerRIN = _data["taxpayerRIN"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): RepresentedTaxpayersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentedTaxpayersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxpayerId"] = this.taxpayerId;
        data["taxpayerRIN"] = this.taxpayerRIN;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["url"] = this.url;
        return data; 
    }

    clone(): RepresentedTaxpayersResponseDto {
        const json = this.toJSON();
        let result = new RepresentedTaxpayersResponseDto();
        result.init(json);
        return result;
    }
}

export interface IRepresentedTaxpayersResponseDto {
    id?: number;
    taxpayerId?: number;
    taxpayerRIN?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    isActive?: boolean;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    url?: string | undefined;
}

export class MetaDataExternal implements IMetaDataExternal {
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IMetaDataExternal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetaDataExternal {
        data = typeof data === 'object' ? data : {};
        let result = new MetaDataExternal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): MetaDataExternal {
        const json = this.toJSON();
        let result = new MetaDataExternal();
        result.init(json);
        return result;
    }
}

export interface IMetaDataExternal {
    totalPages?: number;
    totalCount?: number;
}

export class GetRepresentedTaxpayersExternalResponseDto implements IGetRepresentedTaxpayersExternalResponseDto {
    result?: RepresentedTaxpayersResponseDto[] | undefined;
    metadata?: MetaDataExternal;

    constructor(data?: IGetRepresentedTaxpayersExternalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(RepresentedTaxpayersResponseDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? MetaDataExternal.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRepresentedTaxpayersExternalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepresentedTaxpayersExternalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetRepresentedTaxpayersExternalResponseDto {
        const json = this.toJSON();
        let result = new GetRepresentedTaxpayersExternalResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetRepresentedTaxpayersExternalResponseDto {
    result?: RepresentedTaxpayersResponseDto[] | undefined;
    metadata?: MetaDataExternal;
}

export class TaxtpayerIntermediaryDto implements ITaxtpayerIntermediaryDto {
    id?: number;
    taxpayerId?: number;
    representedTaxpayerId?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    representationFrom?: Date;
    representationTo?: Date | undefined;
    status?: IntermediaryStatuses;
    url?: string | undefined;

    constructor(data?: ITaxtpayerIntermediaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxpayerId = _data["taxpayerId"];
            this.representedTaxpayerId = _data["representedTaxpayerId"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.representationFrom = _data["representationFrom"] ? new Date(_data["representationFrom"].toString()) : <any>undefined;
            this.representationTo = _data["representationTo"] ? new Date(_data["representationTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TaxtpayerIntermediaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxtpayerIntermediaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxpayerId"] = this.taxpayerId;
        data["representedTaxpayerId"] = this.representedTaxpayerId;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["representationFrom"] = this.representationFrom ? this.representationFrom.toISOString() : <any>undefined;
        data["representationTo"] = this.representationTo ? this.representationTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["url"] = this.url;
        return data; 
    }

    clone(): TaxtpayerIntermediaryDto {
        const json = this.toJSON();
        let result = new TaxtpayerIntermediaryDto();
        result.init(json);
        return result;
    }
}

export interface ITaxtpayerIntermediaryDto {
    id?: number;
    taxpayerId?: number;
    representedTaxpayerId?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    representationFrom?: Date;
    representationTo?: Date | undefined;
    status?: IntermediaryStatuses;
    url?: string | undefined;
}

export class MetaData implements IMetaData {
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): MetaData {
        const json = this.toJSON();
        let result = new MetaData();
        result.init(json);
        return result;
    }
}

export interface IMetaData {
    totalPages?: number;
    totalCount?: number;
}

export class GetTaxpayerIntermediariesResponseDto implements IGetTaxpayerIntermediariesResponseDto {
    result?: TaxtpayerIntermediaryDto[] | undefined;
    metadata?: MetaData;

    constructor(data?: IGetTaxpayerIntermediariesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TaxtpayerIntermediaryDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? MetaData.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaxpayerIntermediariesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxpayerIntermediariesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetTaxpayerIntermediariesResponseDto {
        const json = this.toJSON();
        let result = new GetTaxpayerIntermediariesResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetTaxpayerIntermediariesResponseDto {
    result?: TaxtpayerIntermediaryDto[] | undefined;
    metadata?: MetaData;
}

export class IntermediaryRepresentationDto implements IIntermediaryRepresentationDto {
    /** Gets or sets intermediary representation id. */
    representationId!: number | undefined;
    /** Gets or sets intermediary taxpayer id. */
    taxpayerId!: number;
    /** Gets or sets representation start date. */
    activeFrom!: Date | undefined;
    /** Gets or sets representation end date. */
    activeTo!: Date | undefined;
    /** Gets or sets a value indicating whether intermediary can view document. */
    canViewDocument!: boolean;
    /** Gets or sets a value indicating whether intermediary can submit document. */
    canSubmitDocument!: boolean;
    /** Gets or sets a value indicating whether intermediary can cancel document. */
    canCancelDocument!: boolean;
    /** Gets or sets a value indicating whether intermediary can reject document. */
    canRejectDocument!: boolean;
    /** Gets or sets a value indicating whether intermediary can export document. */
    canExportDocument!: boolean;
    /** Gets or sets a value indicating whether intermediary can decline cancellation. */
    canDeclineCancellation!: boolean;
    /** Gets or sets a value indicating whether intermediary candecline rejection. */
    canDeclineRejection!: boolean;
    /** Gets or sets a value indicating whether intermediary can view notifications. */
    canViewNotifications!: boolean;
    /** Gets or sets a value indicating whether intermediary can manage taxpayer codes. */
    canManageTaxpayerCodes!: boolean;

    constructor(data?: IIntermediaryRepresentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.representationId = _data["representationId"];
            this.taxpayerId = _data["taxpayerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.canViewDocument = _data["canViewDocument"];
            this.canSubmitDocument = _data["canSubmitDocument"];
            this.canCancelDocument = _data["canCancelDocument"];
            this.canRejectDocument = _data["canRejectDocument"];
            this.canExportDocument = _data["canExportDocument"];
            this.canDeclineCancellation = _data["canDeclineCancellation"];
            this.canDeclineRejection = _data["canDeclineRejection"];
            this.canViewNotifications = _data["canViewNotifications"];
            this.canManageTaxpayerCodes = _data["canManageTaxpayerCodes"];
        }
    }

    static fromJS(data: any): IntermediaryRepresentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryRepresentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["representationId"] = this.representationId;
        data["taxpayerId"] = this.taxpayerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["canViewDocument"] = this.canViewDocument;
        data["canSubmitDocument"] = this.canSubmitDocument;
        data["canCancelDocument"] = this.canCancelDocument;
        data["canRejectDocument"] = this.canRejectDocument;
        data["canExportDocument"] = this.canExportDocument;
        data["canDeclineCancellation"] = this.canDeclineCancellation;
        data["canDeclineRejection"] = this.canDeclineRejection;
        data["canViewNotifications"] = this.canViewNotifications;
        data["canManageTaxpayerCodes"] = this.canManageTaxpayerCodes;
        return data; 
    }

    clone(): IntermediaryRepresentationDto {
        const json = this.toJSON();
        let result = new IntermediaryRepresentationDto();
        result.init(json);
        return result;
    }
}

export interface IIntermediaryRepresentationDto {
    /** Gets or sets intermediary representation id. */
    representationId: number | undefined;
    /** Gets or sets intermediary taxpayer id. */
    taxpayerId: number;
    /** Gets or sets representation start date. */
    activeFrom: Date | undefined;
    /** Gets or sets representation end date. */
    activeTo: Date | undefined;
    /** Gets or sets a value indicating whether intermediary can view document. */
    canViewDocument: boolean;
    /** Gets or sets a value indicating whether intermediary can submit document. */
    canSubmitDocument: boolean;
    /** Gets or sets a value indicating whether intermediary can cancel document. */
    canCancelDocument: boolean;
    /** Gets or sets a value indicating whether intermediary can reject document. */
    canRejectDocument: boolean;
    /** Gets or sets a value indicating whether intermediary can export document. */
    canExportDocument: boolean;
    /** Gets or sets a value indicating whether intermediary can decline cancellation. */
    canDeclineCancellation: boolean;
    /** Gets or sets a value indicating whether intermediary candecline rejection. */
    canDeclineRejection: boolean;
    /** Gets or sets a value indicating whether intermediary can view notifications. */
    canViewNotifications: boolean;
    /** Gets or sets a value indicating whether intermediary can manage taxpayer codes. */
    canManageTaxpayerCodes: boolean;
}

/** Intermediary Representations Request Dto. */
export class IntermediaryRepresentationsRequestDto implements IIntermediaryRepresentationsRequestDto {
    /** Gets or sets active intermediary taxpayer representation. */
    activeIntermediaryTaxpayerRepresentation!: IntermediaryRepresentationDto[] | undefined;
    /** Gets or sets inactive intermediary taxpayer representation. */
    inActiveIntermediaryTaxpayerRepresentation!: IntermediaryRepresentationDto[] | undefined;

    constructor(data?: IIntermediaryRepresentationsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeIntermediaryTaxpayerRepresentation"])) {
                this.activeIntermediaryTaxpayerRepresentation = [] as any;
                for (let item of _data["activeIntermediaryTaxpayerRepresentation"])
                    this.activeIntermediaryTaxpayerRepresentation!.push(IntermediaryRepresentationDto.fromJS(item));
            }
            if (Array.isArray(_data["inActiveIntermediaryTaxpayerRepresentation"])) {
                this.inActiveIntermediaryTaxpayerRepresentation = [] as any;
                for (let item of _data["inActiveIntermediaryTaxpayerRepresentation"])
                    this.inActiveIntermediaryTaxpayerRepresentation!.push(IntermediaryRepresentationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntermediaryRepresentationsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntermediaryRepresentationsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeIntermediaryTaxpayerRepresentation)) {
            data["activeIntermediaryTaxpayerRepresentation"] = [];
            for (let item of this.activeIntermediaryTaxpayerRepresentation)
                data["activeIntermediaryTaxpayerRepresentation"].push(item.toJSON());
        }
        if (Array.isArray(this.inActiveIntermediaryTaxpayerRepresentation)) {
            data["inActiveIntermediaryTaxpayerRepresentation"] = [];
            for (let item of this.inActiveIntermediaryTaxpayerRepresentation)
                data["inActiveIntermediaryTaxpayerRepresentation"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IntermediaryRepresentationsRequestDto {
        const json = this.toJSON();
        let result = new IntermediaryRepresentationsRequestDto();
        result.init(json);
        return result;
    }
}

/** Intermediary Representations Request Dto. */
export interface IIntermediaryRepresentationsRequestDto {
    /** Gets or sets active intermediary taxpayer representation. */
    activeIntermediaryTaxpayerRepresentation: IntermediaryRepresentationDto[] | undefined;
    /** Gets or sets inactive intermediary taxpayer representation. */
    inActiveIntermediaryTaxpayerRepresentation: IntermediaryRepresentationDto[] | undefined;
}

export class GetRepresentationDetailsExternalResponseDto implements IGetRepresentationDetailsExternalResponseDto {
    id!: number;
    taxpayerId!: number;
    representedTaxpayerId!: number;
    intermediaryNamePrimaryLang!: string | undefined;
    intermediaryNameSecondaryLang!: string | undefined;
    representedTaxpayerNamePrimaryLang!: string | undefined;
    representedTaxpayerNameSecondaryLang!: string | undefined;
    representationFrom!: Date;
    representationTo!: Date | undefined;
    status!: IntermediaryStatuses;
    url!: string | undefined;
    canViewDocument!: boolean;
    canSubmitDocument!: boolean;
    canCancelDocument!: boolean;
    canRejectDocument!: boolean;
    canExportDocument!: boolean;
    canDeclineCancellation!: boolean;
    canDeclineRejection!: boolean;
    canViewNotifications!: boolean;
    canManageTaxpayerCodes!: boolean;

    constructor(data?: IGetRepresentationDetailsExternalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxpayerId = _data["taxpayerId"];
            this.representedTaxpayerId = _data["representedTaxpayerId"];
            this.intermediaryNamePrimaryLang = _data["intermediaryNamePrimaryLang"];
            this.intermediaryNameSecondaryLang = _data["intermediaryNameSecondaryLang"];
            this.representedTaxpayerNamePrimaryLang = _data["representedTaxpayerNamePrimaryLang"];
            this.representedTaxpayerNameSecondaryLang = _data["representedTaxpayerNameSecondaryLang"];
            this.representationFrom = _data["representationFrom"] ? new Date(_data["representationFrom"].toString()) : <any>undefined;
            this.representationTo = _data["representationTo"] ? new Date(_data["representationTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.url = _data["url"];
            this.canViewDocument = _data["canViewDocument"];
            this.canSubmitDocument = _data["canSubmitDocument"];
            this.canCancelDocument = _data["canCancelDocument"];
            this.canRejectDocument = _data["canRejectDocument"];
            this.canExportDocument = _data["canExportDocument"];
            this.canDeclineCancellation = _data["canDeclineCancellation"];
            this.canDeclineRejection = _data["canDeclineRejection"];
            this.canViewNotifications = _data["canViewNotifications"];
            this.canManageTaxpayerCodes = _data["canManageTaxpayerCodes"];
        }
    }

    static fromJS(data: any): GetRepresentationDetailsExternalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepresentationDetailsExternalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxpayerId"] = this.taxpayerId;
        data["representedTaxpayerId"] = this.representedTaxpayerId;
        data["intermediaryNamePrimaryLang"] = this.intermediaryNamePrimaryLang;
        data["intermediaryNameSecondaryLang"] = this.intermediaryNameSecondaryLang;
        data["representedTaxpayerNamePrimaryLang"] = this.representedTaxpayerNamePrimaryLang;
        data["representedTaxpayerNameSecondaryLang"] = this.representedTaxpayerNameSecondaryLang;
        data["representationFrom"] = this.representationFrom ? this.representationFrom.toISOString() : <any>undefined;
        data["representationTo"] = this.representationTo ? this.representationTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["url"] = this.url;
        data["canViewDocument"] = this.canViewDocument;
        data["canSubmitDocument"] = this.canSubmitDocument;
        data["canCancelDocument"] = this.canCancelDocument;
        data["canRejectDocument"] = this.canRejectDocument;
        data["canExportDocument"] = this.canExportDocument;
        data["canDeclineCancellation"] = this.canDeclineCancellation;
        data["canDeclineRejection"] = this.canDeclineRejection;
        data["canViewNotifications"] = this.canViewNotifications;
        data["canManageTaxpayerCodes"] = this.canManageTaxpayerCodes;
        return data; 
    }

    clone(): GetRepresentationDetailsExternalResponseDto {
        const json = this.toJSON();
        let result = new GetRepresentationDetailsExternalResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetRepresentationDetailsExternalResponseDto {
    id: number;
    taxpayerId: number;
    representedTaxpayerId: number;
    intermediaryNamePrimaryLang: string | undefined;
    intermediaryNameSecondaryLang: string | undefined;
    representedTaxpayerNamePrimaryLang: string | undefined;
    representedTaxpayerNameSecondaryLang: string | undefined;
    representationFrom: Date;
    representationTo: Date | undefined;
    status: IntermediaryStatuses;
    url: string | undefined;
    canViewDocument: boolean;
    canSubmitDocument: boolean;
    canCancelDocument: boolean;
    canRejectDocument: boolean;
    canExportDocument: boolean;
    canDeclineCancellation: boolean;
    canDeclineRejection: boolean;
    canViewNotifications: boolean;
    canManageTaxpayerCodes: boolean;
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}